import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { CreateAej, aej } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { FormularioRelatorioAej } from './form'

export default function GerarRelatorioAEJ() {
    const { mutateAsync, isLoading } = aej.mutations.useCreate({
        invalidateQuery: true,
    })
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<CreateAej> = async data =>
        mutateAsync(
            { ...data, empresaId },
            {
                onSuccess: () => {
                    toast.success('Relatório gerado com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['create', 'AEJ'])}
        >
            <Dialog.Title>Gerar relatório AEJ</Dialog.Title>
            <Dialog.Content dividers>
                <FormularioRelatorioAej />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Gerar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
